module.exports = __webpack_public_path__ + "img/023-reaction.a8756a25.svg";